import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { dateOnlyBodyTemplate } from '../../../../utils/dateUtils';
import { useLanguage } from '../../../../contexts/LanguageContext';

/**
 * Eğitim Raporları listesi. Satırlar 3.1'deki rapor nesnesidir (alt satırlar — maliyet/
 * katılımcı/eğitmen — olmadan); `trainingTypeText`/`planningLocationText` yalnızca cevapta
 * gelir (doc §3.1, §3.4). Düzenleme artık modal değil, sayfa (`createEditForm/TrainingReportCreateEdit.jsx`)
 * — `TrainingCatalogTable.jsx` ile aynı desen. Bkz. docs/LMS-Egitim-Raporlari-API.md §3.
 */
const TrainingReportTable = ({ reports, loading }) => {
    const { th } = useLanguage();
    const navigate = useNavigate();

    const isActiveBodyTemplate = (row) => (Number(row.isActive) === 0 ? th('common.inactive', { fallback: 'Pasif' }) : th('common.active', { fallback: 'Aktif' }));

    const actionBodyTemplate = (row) => (
        <div className="flex gap-2 justify-content-center">
            <i className="pi pi-pencil cursor-pointer text-blue-500 hover:text-blue-700" style={{ fontSize: '1.1rem' }} title={th('common.edit')} onClick={() => navigate(`/learning-management-system/training-report/${row.id}`)} />
        </div>
    );

    return (
        <DataTable value={reports} loading={loading} dataKey="id" emptyMessage={th('trainingReport.emptyMessage')} className="p-datatable-gridlines" showGridlines>
            <Column body={actionBodyTemplate} style={{ width: '4rem' }} align="center" />
            <Column field="vehicleModel" header={th('trainingReport.columnVehicleModel')} style={{ width: '10rem' }} />
            <Column field="trainingTypeText" header={th('trainingReport.columnTrainingType')} style={{ width: '10rem' }} />
            <Column field="planningLocationText" header={th('trainingReport.columnLocation')} style={{ width: '10rem' }} />
            <Column field="trainingStartDate" header={th('trainingReport.columnStart')} style={{ width: '9rem' }} body={(row) => dateOnlyBodyTemplate(row, 'trainingStartDate')} />
            <Column field="trainingEndDate" header={th('trainingReport.columnEnd')} style={{ width: '9rem' }} body={(row) => dateOnlyBodyTemplate(row, 'trainingEndDate')} />
            <Column field="reportType" header={th('trainingReport.columnReportType')} style={{ width: '9rem' }} />
            <Column field="numberOfParticipants" header={th('trainingReport.columnParticipants')} style={{ width: '8rem' }} />
            <Column field="isActive" header={th('common.status')} style={{ width: '8rem' }} body={isActiveBodyTemplate} />
        </DataTable>
    );
};

export default TrainingReportTable;
